<template>
  <section class="evaluation-item">
    <v-stepper v-model="currentStep">
      <v-stepper-header class="elevation-1">
        <v-divider></v-divider>
        <v-stepper-step step="1" :complete="currentStep > 1" :editable="true"
          complete-icon="fal fa-check" edit-icon="fal fa-check" color="grey lighten-1">
          Perimetria
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :editable="(currentEvaluation && currentEvaluation._id)"
          complete-icon="fal fa-check" edit-icon="fal fa-check" color="grey lighten-3">
          Fotos
        </v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <user-evaluations-item-form :user="currentUser"
            :currentEvaluationForm="currentEvaluation"></user-evaluations-item-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <user-evaluations-item-photos :currentEvaluationPhotos="currentEvaluation" ></user-evaluations-item-photos>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </section>
</template>

<script>
import EventBus from '@/event-bus'

import UserEvaluationsItemForm from '@/components/user/evaluations/UserEvaluationsItemForm'
import UserEvaluationsItemPhotos from '@/components/user/evaluations/UserEvaluationsItemPhotos'

export default {
  props: ['evaluation', 'user'],

  data: () => ({
    currentStep: 1,
    photos: [null],
    loadingRequest: false,
    currentUser: {},
    currentEvaluation: {}
  }),

  beforeDestroy () {
    EventBus.$off('evaluationCurrentStep')
  },

  mounted () {
    if (!this.user) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    } else {
      this.currentUser = this.user
    }

    if (this.evaluation) {
      this.currentEvaluation = this.evaluation
    }

    EventBus.$on('evaluationCurrentStep', step => {
      this.currentStep = step
    })
  },

  components: { UserEvaluationsItemForm, UserEvaluationsItemPhotos }
}
</script>

<style scoped>
.application .theme--light.v-stepper,
.theme--light .v-stepper,
.v-stepper__header {
  box-shadow: none !important;
}

.v-stepper__header {
  background: #f0f0f0;
}

.v-stepper__content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserEvaluationsItem.vue